<div class="file-attachments-container p-3 border-round-xl surface-card border-1 surface-border">
    <div class="flex justify-content-between align-items-center mb-3">
        <h3 class="m-0 text-900 font-bold flex align-items-center gap-2">
            <i class="pi pi-paperclip text-primary"></i>
            {{ title }}
            <p-tag *ngIf="files().length > 0" [value]="files().length.toString()" severity="info" [rounded]="true"></p-tag>
        </h3>
        <p-fileUpload mode="basic" name="file" [auto]="true" (onSelect)="onUpload($event)"
            chooseLabel="Subir Archivo" chooseIcon="pi pi-plus" [styleClass]="'p-button-sm p-button-rounded border-round-lg'" [disabled]="uploading()"></p-fileUpload>
    </div>

    <div *ngIf="loading()" class="flex justify-content-center py-4">
        <p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4"></p-progressSpinner>
    </div>

    <div *ngIf="!loading() && files().length === 0" class="flex flex-column align-items-center gap-2 py-5 text-400">
        <i class="pi pi-cloud-upload text-4xl"></i>
        <span>No hay archivos adjuntos aún</span>
    </div>

    <div *ngIf="!loading() && files().length > 0" class="file-list mt-2">
        <div *ngFor="let file of files()" class="file-item flex align-items-center justify-content-between p-3 mb-2 border-round-lg surface-50 border-1 surface-border hover:surface-100 transition-colors transition-duration-200">
            <div class="flex align-items-center gap-3 overflow-hidden">
                <i [class]="getFileIcon(file.name)" style="font-size: 1.5rem"></i>
                <div class="flex flex-column overflow-hidden">
                    <span class="text-900 font-medium truncate" [pTooltip]="file.name">{{ file.name.split('/').pop() }}</span>
                    <small class="text-500">{{ file.createdAt | date:'dd/MM/yyyy HH:mm' }} • {{ formatSize(file.size || 0) }}</small>
                </div>
            </div>
            <div class="flex gap-1">
                <p-button icon="pi pi-download" [text]="true" severity="secondary" (onClick)="downloadFile(file)" pTooltip="Descargar/Ver"></p-button>
                <p-button icon="pi pi-trash" [text]="true" severity="danger" (onClick)="deleteFile(file)" pTooltip="Eliminar" [disabled]="loading()"></p-button>
            </div>
        </div>
    </div>
</div>
